import useErrorMessage from '@shared/hooks/useErrorMessage';
import { ComponentType } from 'react';
import { useFormField, useRevalidateFields } from './Form';

type ControlledFormFieldProps<T extends Record<string, any>> = {
  name: string;
  Component: ComponentType<T>;
  revalidates?: string[] | string;
} & T;

const ControlledFormField = <T extends Record<string, any>>(props: ControlledFormFieldProps<T>) => {
  const {
    error,
    required,
    onChange: formOnChange,
    setFieldValue: _1,
    validateField: _2,
    ...field
  } = useFormField(props.name);
  const { Component, revalidates, ...rest } = props;
  const revalidateRelevantFields = useRevalidateFields(revalidates);
  const errorMessage = useErrorMessage(error);
  const mergedProps = {
    ...rest,
    ...field,
    onChange: async (value: any) => {
      formOnChange(value);
      await revalidateRelevantFields();
    },
    checked: typeof field.value === 'boolean' ? field.value : undefined,
    required: props.required ?? required,
    ...(errorMessage && { error: !!errorMessage, helperText: errorMessage }),
  };
  return <Component {...(mergedProps as T)} />;
};

export default ControlledFormField;
